import { render, staticRenderFns } from "./VideoManageList.vue?vue&type=template&id=a4553ddc&scoped=true&"
import script from "./VideoManageList.vue?vue&type=script&lang=js&"
export * from "./VideoManageList.vue?vue&type=script&lang=js&"
import style0 from "./VideoManageList.vue?vue&type=style&index=0&id=a4553ddc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4553ddc",
  null
  
)

export default component.exports